import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import { RotateCcwKey } from 'lucide-vue-next';

export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordButton',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: "edit",
    size: "xs"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('users.js.reset.title')), 1),
      _createVNode(_unref(RotateCcwKey))
    ]),
    _: 1
  }))
}
}

})